import { Injectable } from '@angular/core';
import { IUser } from '../models';
import { SerializationUtil } from 'utility/serialization.util';

@Injectable({
  providedIn: 'root'
})
export class RemoteLoggerService {
  readonly ERROR_DEFAULT_MESSAGE = 'Something strange happened.  Please try again';

  normalizeError(error: any): Error {
    if (!error) return new Error(this.ERROR_DEFAULT_MESSAGE);

    if (typeof error === 'string') {
      return new Error(error);
    }

    if (typeof error.error?.message === 'string') {
      return new Error(error.error.message);
    }

    if (error.error && typeof error.error === 'object') {
      if (
        error.name === 'HttpErrorResponse' &&
        error.statusText === 'Unknown Error'
      ) {
        return new Error('Network error.  Please try again.');
      }
      return new Error(error.message);
    }

    if (error.message && typeof error.message === 'object') {
      return error.message;
    }

    return error as Error;
  }

  /**
   * Placeholder init kept for compatibility. Intentionally a no-op so a future logging service
   * can hook in without changing call sites.
   */
  init() {}

  /**
   * Primary capture method replacing previous Raygun implementation.
   * Logs a normalized error and optional custom data to the console.
   */
  capture(error: unknown, data?: object) {
    const normalized = this.normalizeError(error);
    const payload: any = {
      message: normalized.message,
      stack: normalized.stack,
      data: data ? SerializationUtil.toSafeJSONObject(data) : undefined
    };
    // Keeping a consistent prefix so future log processors can parse easily.
    console.error('[capture]', payload);
  }

  setUser(user: IUser) {
    // Previously reported to Raygun – now just log for debugging / future provider handoff.
    if (!user) return;
    console.info('[logging:setUser]', {
      identifier: user.id,
      isAnonymous: user.email?.includes('readytopay.net'),
      email: user.email,
      fullName: user.name
    });
  }

  // TODO make useful or remove
  log(msg: string) {
    console.log(`LOG: ${msg}`);
  }
}
